<template>
    <div id="formBody" class="bg-light">
        <div id="wrapper">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class="container" style="display:block">
                    <a class="navbar-brand" href="#">
                        <v-img border="0" src="@/assets/sygnali_logo_450.png" contain style="width:20%" alt="Logo systemu Sygnali" title="Logo systemu Sygnali"/>
                    </a>
                    <div class="tmenu">
                        <a class="link" href="https://pomoc.mwc.pl/sygnalista" target="_blank" aria-label="Przejdż do strony pomoc.mwc.pl, strona otworzy się w nowym oknie" title="Przejdż do strony pomoc.mwc.pl, strona otworzy się w nowym oknie">
                            <i class="fal fa-question-circle" aria-hidden="true"></i> Pomoc
                        </a>
                        <button class="link" @click="goToSygnalistInbox()" style="cursor:pointer" aria-label="Przejdź do skrzynki odbiorczej sygnalistów, strona otworzy się w nowym oknie" title="Przejdź do skrzynki odbiorczej sygnalistów, strona otworzy się w nowym oknie">
                            <i class="fal fa-inbox-in" aria-hidden="true"></i> Skrzynka odbiorcza
                        </button>
                        <button id="wcaglink" @click="wcag()" class="link" style="cursor:pointer" aria-label="Włącz tryb WCAG" title="Włącz tryb WCAG"><i class="fal fa-wheelchair"></i> WCAG</button>
                        <button v-if="showAccessibilityStatement" id="accessstatement" @click="openAccessibilityStatement()" class="link" style="cursor:pointer" aria-label="Przejdź do deklaracji dostępności, strona otworzy się w nowym oknie" title="Przejdź do deklaracji dostępności, strona otworzy się w nowym oknie"><i class="fal fa-paperclip"></i> Deklaracja dostępności</button>
                    </div>
                    <div class="cb"></div>
                </div>
            </nav>
            <div id="sterowanie">       
                <button class="kontrast" @click="kontrast()" style="cursor:pointer" aria-label="zmień kontrast"><i class="fa fa-adjust" aria-hidden="true"></i> zmień kontrast</button>
                <button @click="font(0.1)" style="cursor:pointer" aria-label="powiększ czcionkę"><i class="fa fa-plus" aria-hidden="true"></i> powiększ czcionkę</button>
                <button @click="font(-0.1)" style="cursor:pointer" aria-label="pomniejsz czcionkę"><i class="fa fa-minus" aria-hidden="true"></i>pomniejsz czcionkę</button>
            </div>
            <div class="container">
                <main>
                    <div class="py-5 text-center">
                    </div>

                    <v-row v-if="customerIsBlocked == true">
                        <v-col cols="12">
                            <v-card class="employee-list mb-1">
                                <v-card-title class="pa-6 pb-3">
                                    <p>Wysyłanie zgłoszeń zablokowane!</p>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-card-text role="alert" aria-live="assertive">Konto wskazanej instytucji/firmy jest obecnie nieaktywne z powodu wygaśnięcia dotychczasowej licencji. Możliwość wysyłania zgłoszeń zostanie aktywowana w momencie odnowienia licencji przez wskazaną jednostkę.</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <div class="row rfl" v-if="customerIsBlocked == false">
                        <div class="col-8">
                            <div class="row">
                                <div class="col-8 col-md-8" style="float: left;">
                                    <h4 class="thin">Formularz zgłoszenia dla Sygnalisty</h4>
                                    <h3 class="mb-3"><strong>{{company}}</strong></h3>
                                </div>
                                <div class="col-2 col-md-4">
                                    <v-img v-if="logo.name != null && logo.name.length > 0" :src="logo.name" style="width: 200px; float: right;" :alt="'Logo instytucji ' + company" :title="'Logo instytucji ' + company"></v-img>
                                </div>
                            </div>
                            <input id="pkid" name="pkid" type="hidden" value="0">
                            <div class="row g-3">
                                <div class="col-12">
                                    <div class="input-group has-validation">
                                        <label class="input-group-text" for="kategoria">Kategoria zgłoszenia<span aria-label="Pole wymagane"> *</span></label>
                                        <select id="kategoria" class="form-select" name="kategoria" required @change="getFormForCategory($event)" aria-describedby="category-required">
                                            <option v-for="item in categories" :key="item.id" :value="item.id">
                                                {{item.name}}
                                            </option>
                                        </select>
                                        <span id="category-required" class="visually-hidden">To pole jest wymagane</span>
                                    </div>
                                </div>
                            </div>
                            <form id="formularz" class="needs-validation" :aria-busy="waiting" @submit="(e) => e.preventDefault()">
                                <div class="mt-2 row g-3">
                                    <div v-for="item in form" :key="item.id">
                                        <div class="col-12" v-if="item.type == 2">
                                            <div class="input-group has-validation">
                                                <label class="input-group-text" :for="'input_'+item.id+'_field'">
                                                    {{item.label}}
                                                    <span v-if="item.required" class="required" aria-label="Pole wymagane"> *</span>
                                                </label>
                                                <span class="input-group-text" title="Zawartość tego pola zostanie zaszyfrowana">
                                                    <i class="fal fa-shield-check" aria-hidden="true"></i>
                                                </span>
                                                <input :id="'input_'+item.id+'_field'"
                                                       class="form-control encrypt"
                                                       encrypted="1"
                                                       :name="item.label+'&'+item.type+'#'+item.id"
                                                       placeholder=""
                                                       :required="item.required"
                                                       minlength="3"
                                                       type="text"
                                                       :aria-describedby="item.required ? 'hint_'+item.id : undefined">
                                                <span v-if="item.required" :id="'hint_'+item.id" class="visually-hidden">To pole jest wymagane</span>
                                                <div class="invalid-feedback">Pole wymagane - minimum 3 znaki</div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="item.type == 1">
                                            <label class="form-label" :for="'zgloszenie_'+item.id+'_field'">{{item.label}}<span v-if="item.required" class="required" aria-label="Pole wymagane">*</span></label>
                                            <div class="input-group has-validation">
                                                <span class="input-group-text" title="Zawartość tego pola zostanie zaszyfrowana">
                                                    <i class="fal fa-shield-check" aria-hidden="true"></i>
                                                </span>
                                                <textarea :id="'zgloszenie_'+item.id+'_field'"
                                                          class="encrypt form-control"
                                                          encrypted="1"
                                                          :name="item.label+'&'+item.type+'#'+item.id"
                                                          :required="item.required"
                                                          rows="10"
                                                          minlength="4"
                                                          :aria-describedby="item.required ? 'hint2_'+item.id : undefined"></textarea>
                                                <span v-if="item.required" :id="'hint2_'+item.id" class="visually-hidden">To pole jest wymagane</span>
                                                <div class="invalid-feedback">Pole wymagane - minimum 4 znaki</div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="item.type == 4">
                                            <div class="input-group has-validation">
                                                <label class="input-group-text" :for="'select_'+item.id+'_field'">{{prepareLabelForSelect(item.label)}}<span v-if="item.required" class="required" aria-label="Pole wymagane"> *</span></label>
                                                <span class="input-group-text" title="Zawartość tego pola zostanie zaszyfrowana">
                                                    <i class="fal fa-shield-check" aria-hidden="true"></i>
                                                </span>
                                                <select class="encrypt form-select"
                                                        encrypted="1"
                                                        :required="item.required"
                                                        :id="'select_'+item.id+'_field'"
                                                        :name="item.label+'&'+item.type+'#'+item.id"
                                                        :aria-describedby="item.required ? 'hint3_'+item.id : undefined">
                                                    <option value="" selected>Wybierz</option>
                                                    <option v-for="item in preapareOptions(item.label)" :key="item.id" :value="item">{{item}}</option>
                                                </select>
                                                <span v-if="item.required" :id="'hint3_'+item.id" class="visually-hidden">To pole jest wymagane - wybierz  listy</span>
                                                <div class="invalid-feedback">Pole wymagane - wybierz z listy</div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="item.type == 3">
                                            <div class="form-check">
                                                <input :id="'checkbox_'+item.id+'_field'"
                                                       :name="item.label+'&'+item.type+'#'+item.id"
                                                       class="form-check-input"
                                                       :required="item.required"
                                                       type="checkbox"
                                                       :aria-describedby="item.required ? 'hint4_'+item.id : undefined">
                                                <label v-html="getLabel(item)" class="form-check-label" :for="'checkbox_'+item.id+'_field'"></label>
                                                <span v-if="item.required" :id="'hint4_'+item.id" class="visually-hidden">To pole jest wymagane - zaznacz checkbox</span>
                                                <div class="invalid-feedback">Pole wymagane - zaznacz opcję</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-label" v-if="!isAnonymous" style="margin-bottom: 0px;">Dane sygnalisty</div>
                                    <div class="col-12" v-if="!isAnonymous" style="margin-top: 0px;">
                                        <div class="input-group has-validation">
                                            <label class="input-group-text" for="sygnalistName">Imię i nazwisko<span v-if="!isAnonymous" class="required" aria-label="Pole wymagane"> *</span></label>
                                            <span class="input-group-text" aria-live="polite"><i class="fal fa-info-circle" aria-hidden="true" title="Imię i nazwisko sygnalisty"></i></span>
                                            <input id="sygnalistName"
                                                   class="form-control"
                                                   v-model="sygnalistName"
                                                   :required="!isAnonymous"
                                                   minlength="3"
                                                   :aria-describedby="!isAnonymous ? 'hint5_sygnalis_name' : undefined">
                                            <span v-if="!isAnonymous" id="hint5_sygnalis_name" class="visually-hidden">To pole jest wymagane - minimum 3 znaki</span>
                                            <div class="invalid-feedback">Pole wymagane - minimum 3 znaki</div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-if="!isAnonymous" style="margin-top: 0px;">
                                        <div class="input-group has-validation">
                                            <label class="input-group-text" for="email">Adres e-mail</label>
                                            <span class="input-group-text" aria-live="polite"><i class="fal fa-info-circle" aria-hidden="true" title="Adres e-mail sygnalisty do kontaktu"></i></span>
                                            <input id="email" class="form-control" v-model="email" type="email">
                                            <div class="invalid-feedback">Podaj poprawny adres e-mail</div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-if="!isAnonymous" style="margin-top: 0px;">
                                        <div class="input-group has-validation">
                                            <label class="input-group-text" for="sygnalistPhone">Numer telefonu</label>
                                            <span class="input-group-text" aria-live="polite"><i class="fal fa-info-circle" aria-hidden="true" title="Numer telefonu sygnalisty do kontaktu"></i></span>
                                            <input id="sygnalistPhone" class="form-control" v-model="sygnalistPhone" pattern="^\d{9}$">
                                            <div class="invalid-feedback">Podaj poprawny numer telefonu - 9 cyfr</div>
                                        </div>
                                    </div>
                                </div>
                               
                                <div class="mt-2 row g-3">
                                    <hr>
                                    <div style="padding: 0px; margin: 0px;">
                                        <span>* Pola obowiązkowe</span>
                                    </div>
                                    <div class="col-12" v-if="isFiles">
                                        <h4 class="justify-content-between align-items-center mb-3">
                                            <button class="btn btn-primary" @click="addFile()" style="float:right" role="button" aria-label="dodaj załącznik" :disabled="waiting == true">+ dodaj załącznik</button>
                                            Załączniki
                                        </h4>
                                        <div v-if="files != null && files.length > 0">
                                            <ul class="zalaczniki" v-for="item in files" :key="item[0].name">
                                                <li>
                                                    {{item[0].name}} <v-btn icon @click="deleteFile(item)" :aria-label="'Usuń załącznik '+ item[0].name">
                                                        <v-icon style="color: #D32F2F">mdi-trash-can</v-icon>
                                                    </v-btn>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-else>
                                            <ul class="zalaczniki">
                                                <li>Brak załączników...</li>
                                            </ul>
                                        </div>
                                        <label class="small mt-1">*PDF, DOC, DOCX, JPG, PNG, XLS, XLSX, CSV, MP3, M4A</label>
                                    </div>
                                    <button class="mb-3 w-100 btn btn-primary btn-lg" id="saver" @click="fsubmit()" type="button" aria-label="Zaszyfruj i wyślij zgłoszenie" :disabled="waiting == true">
                                        <span v-if="waiting == false"><i id="unlock" class="far fa-lock-open-alt" aria-hidden="true"></i> Zaszyfruj i wyślij zgłoszenie</span>
                                        <span v-else><v-progress-circular style="margin-left: 20px;" :width="4" indeterminate></v-progress-circular> Trwa szyfrowanie i wysyłanie zgłoszenia</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="col-4">
                            <div class="row" v-if="attachments != null && attachments.length > 0">
                                <h4 class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="text-primary">Do pobrania</span>
                                </h4>
                                <ul v-for="item in attachments" :key="item.id">
                                    <li class="lead">
                                        <button class="download-attachement" @click="getAttachment(item)" :aria-label="'Plik zostanie pobrany przez przeglądarkę. Pobierz '+item.name" :title="'Plik zostanie pobrany przez przeglądarkę. Pobierz '+item.name">{{item.name}}</button>
                                    </li>
                                </ul>
                            </div>
                            <div class="row kanaly" v-if="phoneEnabled || mailEnabled">
                                <h4 class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="text-primary">Dodatkowe kanały zgłoszenia</span>
                                </h4>
                                <h5 v-if="phoneEnabled">Zgłoszenie telefoniczne</h5>
                                <p class="lead" v-if="phoneEnabled">
                                    W celu przekazania zgłoszenia za pomocą telefonu, zadzwoń pod numer <b>+48 616 313 431</b> i podaj następujący kod PIN: <b>{{pin}}</b>.
                                    System Sygnali automatycznie przetworzy Twoje nagranie na tekst i prześle je do właściwego odbiorcy. Nagranie telefoniczne jest anonimowe - nie przekazujemy Twojego numeru telefonu.
                                </p>
                                <h5 v-if="mailEnabled">Zgłoszenie mailowe</h5>
                                <p class="lead" v-if="mailEnabled">
                                    Aby przekazać Twoje zgłoszenie mailem, wyślij je na adres: <b>{{customEmail != null && customEmail.length > 0 ? customEmail : pin}}@my.sygnali.pl</b>.{{ isAnonymous == true ?'Jest to zgłoszenie anonimowe, Twój adres e-mail nie zostanie przekazany odbiorcy.' : '' }}
                                </p>
                                <hr />
                            </div>
                            <div class="row kanaly">
                                <h4 class="d-flex justify-content-between align-items-center mb-3">
                                    <span class="text-primary">Informacje</span>
                                </h4>
                                <p class="lead" v-if="isAnonymous">
                                    Twoje zgłoszenie zostanie przekazane bezpiecznie i anonimowo
                                    do odbiorcy. Odbiorca nie będzie w stanie ustalić nadawcy. Nie podawaj w
                                    zgłoszeniu wrażliwych danych osobowych, jeżeli nie jest to konieczne.
                                </p>
                                <p class="lead" v-else>
                                    Twoje zgłoszenie zostanie przekazane bezpiecznie
                                    do odbiorcy. Nie podawaj w
                                    zgłoszeniu wrażliwych danych osobowych, jeżeli nie jest to konieczne.
                                </p>
                                <p>
                                    Wysyłając zgłoszenie akceptujesz postanowienia
                                    <a href="https://sygnali.pl/regulamin" target="_blank" aria-label="Przejdż do strony regulamiu, strona otworzy się w nowym oknie" title="Przejdż do strony regulamiu, strona otworzy się w nowym oknie">Regulaminu </a>oraz
                                    <a href="https://sygnali.pl/polityka-prywatnosci" target="_blank" aria-label="Przejdż do strony polityki prywatności, strona otworzy się w nowym oknie" title="Przejdż do strony polityki prywatności, strona otworzy się w nowym oknie">
                                        Polityki
                                        Prywatności
                                    </a> systemu Sygnali.
                                </p>
                                <p>Przeczytaj też <a href="https://sygnali.pl/bezpieczenstwo-sygnalisty-2" target="_blank" aria-label="Przejdż do strony ochrona sygnalistów, strona otworzy się w nowym oknie" title="Przejdż do strony ochrona sygnalistów, strona otworzy się w nowym oknie">Jak chronimy Sygnalistów</a>.</p>
                            </div>
                            <div class="row mt-3">
                                <hr>
                                <p class="mt-2">&copy; {{new Date().getFullYear()}} MWC Sp. z o.o.</p>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <SygnaliModal v-show="showSyganliModal" @close="closeModal" :sygnal="sygnal" />
        </div>
    </div>
</template>
<script src="../../../form/bootstrap.bundle.min.js"></script>
<script>
    import Service from '@/services/Service'
    import $ from 'jquery'
    import alertify from 'alertifyjs'
    import CryptoJS from 'crypto-js'
    import SygnaliModal from '@/components/Modals/SygnaliModal'
    export default {
        name: 'SygnaliForm',
        components: {
          SygnaliModal,
        },
        data() {
            return {
                textarea: '',
                title: '',
                files: [],
                company: '',
                showSyganliModal: false,
                waiting: false,
                sygnal: {},
                c: 0,
                f: 1.0,
                main: [],
                categories: [],
                form: {},
                email: '',
                sygnalistName: '',
                sygnalistPhone: '',
                isAnonymous: true,
                isFiles: true,
                pk: '',
                pkid: 0,
                catid: 0,
                attachments: [],
                phoneEnabled: false,
                mailEnabled: false,
                pin: '',
                customEmail: '',
                logo: {
                    id: 0,
                    name: ''
                },
                customerIsBlocked: false,
                showAccessibilityStatement: false
            }
        },
        async mounted() {
            try {
                this.main = (await Service.getSygnaliForm(this.$route.params.companyName)).data,
                this.company = this.main.company,
                this.categories = this.main.categories,
                this.isAnonymous = this.categories[0].anonymous,
                this.isFiles = this.categories[0].files,
                this.catid = this.main.categories[0].id,
                this.attachments = this.main.categories[0].attachments,
                this.form = this.main.fields,
                this.phoneEnabled = this.main.phoneEnabled,
                this.mailEnabled = this.main.mailEnabled,
                this.pin = this.main.pin,
                this.customEmail = this.main.customEmail,
                this.logo = this.main.logo,
                this.showAccessibilityStatement = this.main.showAccessibilityStatement

            } catch (e) {
                if (e.response.status == 409) {
                    this.customerIsBlocked = true;
                }
                else {
                    alert(e.response.status + " - " + e.response.data.toString());
                    this.$router.push({ name: 'Error2' });
                }
            }
        },
        created() {
            document.title = "Sygnali.pl - Formularz zgłoszeniowy";
        },
        methods: {
            preapareOptions(item) {
                var opt = item.split('|')[1];
                var o = opt.split(',');
                return o;
            },
            prepareLabelForSelect(item) {
                return item.split('|')[0];
            },
            getLabel(item) {
                return `${item.label}${item.required ? ' <span class="required" aria-label="Pole wymagane">*</span>' : ''}`;
            },
            async getFormForCategory(item) {
                try {
                   
                    var temp = {
                        companyName: this.$route.params.companyName,
                        id: parseInt(item.target.value)
                    };
                    var result = (await Service.getFieldsForCategory(temp)).data;
                    if (Object.keys(result).length > 0) {
                        this.form = result.fields;

                        var index = this.categories.findIndex(x => x.id == parseInt(item.target.value));
                        if (index != -1) {
                            this.categories[index] = result.category;
                            this.isAnonymous = result.category.anonymous;
                            this.isFiles = result.category.files;
                            this.catid = result.category.id;
                            this.attachments = result.category.attachments;
                        }
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                    this.$router.push({ name: 'Error2' });
                }
            },
            wcag() {
                $("#sterowanie").slideToggle()
            },
            kontrast() {
                if (this.c == 0) {
                    $('#formBody').addClass("black").removeClass('bg-light');
                    this.c = 1;
                }
                else {
                    $('#formBody').removeClass("black").addClass('bg-light');
                    this.c = 0;
                }
            },
            font(x) {
                this.f = this.f + x;
                this.f = Math.round(this.f * 100) / 100
                document.getElementById("wrapper").style.fontSize = this.f + "em";
            },
            closeModal() {
                this.showSyganliModal = false;
                this.textarea = '';
                this.title = '';
                this.files = [];
                this.sygnal = {};
                window.location.reload(true);
            },
            goToSygnalistInbox() {
                let routeData = this.$router.resolve({ name: 'InboxLogin' });
                window.open(routeData.href, '_blank');
            },
            goToHelpPage() {
                window.open('https://pomoc.mwc.pl/sygnalista', '_blank').focus();
            },
            fsubmit() {
                var thisVue = this;
                alertify.confirm('Potwierdź zgłoszenie', 'Czy na pewno chcesz wysłać zgłoszenie?', function () {
                    thisVue.waiting = true;
                    setTimeout(thisVue.wysylaj(), 100);
                }, function () { }).set('labels', { ok: 'Wyślij', cancel: 'Anuluj' });
            },
            wysylaj() {
                var thisVue = this;
                try {
                    
                    const form = document.getElementById("formularz");
                    if (!form.checkValidity()) {
                        alertify.error('Wystąpiły błędy w formularzu. Pola są źle wypełnione. Popraw dane i spróbuj ponownie.');
                        thisVue.waiting = false;
                    } else { thisVue.encrypt(); return false }
                    form.classList.add('was-validated')

                } catch {
                    thisVue.waiting = false;
                }
            },
            encrypt() {
                var thisVue = this;
                alertify.notify('Trwa pobieranie klucza publicznego...');
                setTimeout(async () => { await thisVue.get_public_key() }, 1000);
            },
            async get_public_key() {

                try {
                    var thisVue = this;
                    var result = (await Service.getSygnaliPublicKeyForm(thisVue.$route.params.companyName)).data;
                    if ((Object.keys(result).length > 0)) {
                        alertify.dismissAll();
                        thisVue.pk = result.key;
                        var pkid = result.id;
                        thisVue.pkid = result.id;
                        $('#pkid').val(pkid);
                        alertify.success("Pobrano pomyślnie klucz publiczny.");
                        setTimeout(() => { alertify.notify('Trwa szyfrowanie danych...'); thisVue.szyfruj() }, 800);
                    }
                    else {
                        alert("Błąd podczas pobierania klucza zgłoszenia");
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                }
            },
            szyfruj() {
                var thisVue = this;
                var criteria = $('#formularz').find('input.encrypt,textarea.encrypt').filter(function () {
                    var v = this.value;
                    v = v.replace(/<\/?[^>]+(>|$)/g, "");
                    var c = CryptoJS.AES.encrypt(v, thisVue.pk).toString();
                    this.value = c;
                })

                $('select.encrypt').each(function () {
                    var v = this.value;
                    var n = this.name;
                    v = v.replace(/<\/?[^>]+(>|$)/g, ""); //usuwanie htmla z treści formularzy
                    n = n.replace(/<\/?[^>]+(>|$)/g, "");
                    var c = CryptoJS.AES.encrypt(v, thisVue.pk).toString();
                    var z = "<input class='encrypt form-control' name='" + n + "' type='text' value='" + c + "'>";
                    $(this).replaceWith(z);
                })

                $('.encrypt').each(function () {
                    var n = this.name;
                    $(this).attr("name", n + '_encrypted');
                })

                setTimeout(thisVue.wyslij_dane(), 1100);
            },
            wyslij_dane() {
                var thisVue = this;
                alertify.dismissAll();
                alertify.success('Pomyślnie zaszyfrowano dane.');
                $('#unlock').replaceWith('<i class="far fa-lock-alt"></i>');
                setTimeout(alertify.notify('Trwa wysyłanie zgłoszenia...'), 100);

                var formularz = $('#formularz').serializeArray()
                var formData = JSON.stringify(formularz);
                var w = formData;
                var b64 = this.b64encode(w);
                setTimeout(function () { thisVue.sendMessage(b64) }, 700);
            },
            b64encode(x) {
                var result = btoa(unescape(encodeURIComponent(x)));
                return result;
            },
            b64decode(x) {
                var result = atob(x);
                return result;
            },
            async sendMessage(base64) {
                try {
                    let formData = new FormData();
                    for (var i = 0; i < this.files.length; i++) {
                        let file = this.files[i][0];
                        formData.append('files[' + i + ']', file);
                    }

                    formData.append("msg", base64);
                    formData.append("pkid", parseInt(this.pkid));
                    formData.append("catId", this.catid);
                    formData.append("name", this.sygnalistName);
                    formData.append("phone", this.sygnalistPhone);
                    formData.append("email", this.email);

                    var result = (await Service.saveFileForSignal(this.$route.params.companyName, formData)).data;
                    if (Object.keys(result).length > 0) {
                        this.sygnal = result.message;
                        this.waiting = false;
                        this.showSyganliModal = true;
                        this.files = [];
                    }
                      
                } catch (e) {
                    this.waiting = false;
                    alert(e.response.status + " - " + e.response.data.toString());
                    this.$router.push({ name: 'Error2' });
                }
            },
            addFile() {
                let input = document.createElement('input');
                input.type = 'file';
                input.accept = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' +
                    ',.pdf,.png,.jpg,.jpeg' +
                    ',.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel' +
                    ',.csv,text/csv' +
                    ',audio/mpeg,audio/x-m4a' +
                    ',.zip,application/zip' +
                    ',.7z,application/x-7z-compressed';
                input.multiple = false;
                input.click();

                input.addEventListener('change', (event) => {
                    if (event.target.files[0].size <= 30000000) {
                        if (this.checkMimeType(event.target.files[0].type)) {
                            if (this.files.length > 0) {
                                for (var i = 0; i < this.files.length; i++) {
                                    if (this.files[i][0].name == event.target.files[0].name)
                                        return;
                                }

                                var tempFileSize = 0;
                                for (var j = 0; j < this.files.length; j++) {
                                    tempFileSize += this.files[j][0].size;
                                }
                                tempFileSize += event.target.files[0].size;
                                if (tempFileSize >= 30000000) {
                                    alert("Zbyt duży rozmiar pliku! Suma załączników nie może przekraczać 30MB");
                                    return;
                                }

                                this.files.push(event.target.files);
                            }
                            else {
                                this.files.push(event.target.files);
                            }
                        }
                        else {
                            alert("Nieobsługiwany typ pliku. Pliki obsługiwane to: DOC,DOCX,PDF,JPG,JPEG,PNG,XLS,XLSX,CSV,MP3,M4A")
                        }
                    } else {
                        alert("Zbyt duży rozmiar pliku! Suma załączników nie może przekraczać 30MB");
                    }
                });
            },
            checkMimeType(type) {
                const acceptedMimeTypes = [
                    "application/pdf",
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                    "application/msword", // .doc
                    "text/csv", // .csv
                    "application/vnd.ms-excel", // .xls
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                    "text/plain", // .txt
                    "audio/mpeg", // .mp3
                    "audio/x-m4a", // .m4a
                    "application/zip", // ZIP
                    "application/x-zip-compressed", // ZIP w Windows
                    "application/x-compressed", //  ZIP
                    "application/x-7z-compressed",
                    "application/x-7z",
                    "multipart/x-zip"
                ];

                if (!acceptedMimeTypes.includes(type)) {
                    return false;
                } else {
                    return true;
                }
            },
            deleteFile(item) {
                if (this.files.length > 0) {
                    for (var i = 0; i < this.files.length; i++) {
                        if (this.files[i][0].name == item[0].name) {
                            var index = this.files.indexOf(this.files[i])
                            this.files.splice(index, 1);
                        }
                    }
                }
            },
            async openAccessibilityStatement() {
                try {
                    var result = (await Service.downloadCustomerAccessibilityStatementForm(this.$route.params.companyName));

                    if (result.status == 200) {
                        const contentType = result.headers['content-type'] || 'text/html; charset=utf-8';
                        var blob = new Blob([result.data], { 'type': contentType });
                        var blobUrl = window.URL.createObjectURL(blob);
                        window.open(blobUrl, '_blank');
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                }
            },
           async getAttachment(item) {
                try {
                    var temp = {
                        companyName: this.$route.params.companyName,
                        fileId: item.id,
                        fileName: item.name,
                        catId: this.catid
                    };

                    var result = (await Service.downloadAttachment(temp));

                    if (result.status == 200) {
                        const contentType = result.headers['content-type'];
                        var a = document.createElement('a');
                        var blob = new Blob([result.data], { 'type': contentType });
                        a.href = window.URL.createObjectURL(blob);
                        a.download = item.name;
                        a.click();
                    }
                } catch (e) {
                    alert(e.response.status + " - " + e.response.data.toString());
                }
            }
        },
    }

</script>

<style scoped>
    @import '../../../form/custom.css';
   /* @import '../../../form/form-validation.css';*/
    @import '../../../form/fontawesome/css/all.css';
    @import '../../../form/bootstrap.css';
    @import '../../../form/alertify/alertify.min.css';
    @import '../../../form/alertify/themes/default.css';


 .bd-placeholder-img {
	font-size: 1.125rem;
	text-anchor: middle;
	-webkit-user-select: none;
	-moz-user-select: none;
	user-select: none;
}
@media (min-width: 768px) {
.bd-placeholder-img-lg {
	font-size: 3.5rem;
}
}

    @media only screen and (max-width: 1000px) {
        .col-8, .col-4 {
            width: 100%;
        }
    }

    row.kanaly {
        font-size: 0.8em;
    }

    .kanaly h5 {
        font-size: 1.2em !important;
    }

</style>
